// ======================================================================
// FILE:
// src/modules/service_crm/installed_products/pages/InstalledProductDetailPage.js
//
// MODULE: Service CRM
// FEATURE: Installed Product Detail View
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import installedProductService
from "../../services/installedProductService";

import FormSectionCard
from "../../components/FormSectionCard";

export default function InstalledProductDetailPage() {

  const navigate = useNavigate();

  const { id } = useParams();

  // -------------------------------------------------------------------
  // STATE
  // -------------------------------------------------------------------
  const [loading, setLoading] =
    useState(true);

  const [row, setRow] =
    useState(null);

  // -------------------------------------------------------------------
  // LOAD DETAIL
  // -------------------------------------------------------------------
  useEffect(() => {

    loadDetail();

  }, [id]);

  // -------------------------------------------------------------------
  // LOAD PRODUCT
  // -------------------------------------------------------------------
  async function loadDetail() {

    try {

      setLoading(true);

      const res =
        await installedProductService
          .getInstalledProduct(id);

      setRow(res);

    } finally {

      setLoading(false);
    }
  }

  // -------------------------------------------------------------------
  // FIELD VIEW COMPONENT
  // -------------------------------------------------------------------
  const Field = ({
    label,
    value,
  }) => (

    <div>

      <div
        style={{
          fontSize: 12,

          color: "#6c757d",

          marginBottom: 4,

          fontWeight: 600,
        }}
      >
        {label}
      </div>

      <div
        style={{
          fontSize: 14,

          fontWeight: 500,

          color: "#212529",

          minHeight: 24,
        }}
      >
        {value || "-"}
      </div>

    </div>
  );

  // -------------------------------------------------------------------
  // GRID STYLE
  // -------------------------------------------------------------------
  const gridStyle = {
    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(240px, 1fr))",

    gap: 18,
  };

  // -------------------------------------------------------------------
  // STATUS BADGE
  // -------------------------------------------------------------------
  function renderStatus(status) {

    const value =
      (status || "").toLowerCase();

    let background = "#6c757d";

    if (value === "commissioned") {
      background = "#198754";
    }

    else if (value === "pending") {
      background = "#fd7e14";
    }

    else if (value === "rejected") {
      background = "#dc3545";
    }

    return (

      <span
        style={{
          background,

          color: "#fff",

          padding: "6px 12px",

          borderRadius: 20,

          fontSize: 13,

          fontWeight: 600,
        }}
      >
        {status || "N/A"}
      </span>
    );
  }

  // -------------------------------------------------------------------
  // LOADING
  // -------------------------------------------------------------------
  if (loading) {

    return (

      <div
        style={{
          padding: 40,
        }}
      >
        Loading product details...
      </div>
    );
  }

  // -------------------------------------------------------------------
  // NO DATA
  // -------------------------------------------------------------------
  if (!row) {

    return (

      <div
        style={{
          padding: 40,
        }}
      >
        Product not found.
      </div>
    );
  }

  // -------------------------------------------------------------------
  // RENDER
  // -------------------------------------------------------------------
  return (

    <div>

      {/* ========================================================= */}
      {/* HEADER */}
      {/* ========================================================= */}

      <div
        style={{
          background:
            "linear-gradient(90deg, #0d6efd, #3d8bfd)",

          borderRadius: 14,

          padding: "18px 22px",

          color: "#fff",

          marginBottom: 20,

          display: "flex",

          justifyContent:
            "space-between",

          alignItems: "center",

          flexWrap: "wrap",

          gap: 16,
        }}
      >

        {/* LEFT */}
        <div>

          <div
            style={{
              fontSize: 22,

              fontWeight: 700,
            }}
          >
            {row.instance_id}
          </div>

          <div
            style={{
              marginTop: 4,

              fontSize: 14,

              opacity: 0.9,
            }}
          >
            {row.customer_name}
          </div>

        </div>

        {/* RIGHT */}
        <div
          style={{
            display: "flex",

            gap: 10,

            alignItems: "center",

            flexWrap: "wrap",
          }}
        >

          {/* STATUS */}
          {renderStatus(
            row.commissioning_status
          )}

          {/* EDIT */}
          <button
            className="btn btn-light"

            onClick={() =>
              navigate(
                `/service-crm/installed-products/${row.id}/edit`
              )
            }
          >
            Edit
          </button>

          {/* CREATE TICKET */}
          <button
            className="btn btn-warning"

            onClick={() =>
              navigate(
                `/service-crm/tickets/create?product_id=${row.id}`
              )
            }
          >
            Create Ticket
          </button>

          {/* BACK */}
          <button
            className="btn btn-outline-light"

            onClick={() =>
              navigate(
                "/service-crm/installed-products"
              )
            }
          >
            Back
          </button>

        </div>

      </div>

      {/* ========================================================= */}
      {/* INVOICE DETAILS */}
      {/* ========================================================= */}

      <FormSectionCard
        title="Invoice Details"
        collapsible
        defaultExpanded={true}
      >

        <div style={gridStyle}>

          <Field
            label="Invoice Number"
            value={row.invoice_number}
          />

          <Field
            label="Invoice Date"
            value={row.invoice_date}
          />

          <Field
            label="OA Number"
            value={row.oa_number}
          />

          

          <Field
            label="Canopy Number"
            value={row.canopy_number}
          />

        </div>

      </FormSectionCard>

      {/* ========================================================= */}
      {/* CUSTOMER & SITE */}
      {/* ========================================================= */}

      <FormSectionCard
        title="Customer & Site"
        collapsible
        defaultExpanded={true}
      >

        <div style={gridStyle}>

          <Field
            label="Customer Name"
            value={row.customer_name}
          />

          <Field
            label="Customer Type"
            value={row.customer_type}
          />

          <Field
            label="Contact Person"
            value={row.contact_person}
          />

          <Field
            label="Contact Number"
            value={row.contact_number}
          />

          <Field
            label="Email ID"
            value={row.email_id}
          />

          <Field
            label="Country"
            value={row.country}
          />

          <Field
            label="State"
            value={row.state}
          />

          <Field
            label="City"
            value={row.city}
          />

          <Field
            label="PIN Code"
            value={row.pin_code}
          />

        </div>

        {/* ADDRESS BLOCKS */}

        <div
          style={{
            marginTop: 24,
          }}
        >

          <div
            style={{
              marginBottom: 20,
            }}
          >

            <div
              style={{
                fontSize: 12,

                color: "#6c757d",

                marginBottom: 6,

                fontWeight: 600,
              }}
            >
              Billing Address
            </div>

            <div
              style={{
                background: "#f8f9fa",

                borderRadius: 10,

                padding: 14,

                minHeight: 70,
              }}
            >
              {row.billing_address || "-"}
            </div>

          </div>

          <div>

            <div
              style={{
                fontSize: 12,

                color: "#6c757d",

                marginBottom: 6,

                fontWeight: 600,
              }}
            >
              Site Address
            </div>

            <div
              style={{
                background: "#f8f9fa",

                borderRadius: 10,

                padding: 14,

                minHeight: 70,
              }}
            >
              {row.site_address || "-"}
            </div>

          </div>

        </div>

      </FormSectionCard>

      {/* ========================================================= */}
      {/* MACHINE DETAILS */}
      {/* ========================================================= */}

      <FormSectionCard
        title="Machine Details"
        collapsible
        defaultExpanded={false}
      >

        <div style={gridStyle}>

          <Field
              label="Emission Norm"
              value={row.emission_norm}
          />

          <Field
              label="Engine Model No"
              value={row.engine_model_no}
          />

          <Field
              label="KVA Rating"
              value={row.kva_rating}
          />

          <Field
              label="Engine App Code"
              value={row.engine_app_code}
          />

          <Field
              label="Engine Serial No"
              value={row.engine_serial_no}
          />

          <Field
              label="Engine KRM No"
              value={row.engine_krm_no}
          />

          <Field
              label="Instance ID"
              value={row.instance_id}
          />

          <Field
              label="Engine Make"
              value={row.engine_make}
          />
              


        </div>

      </FormSectionCard>
      {/* ========================================================= */}
    {/* ALTERNATOR DETAILS */}
    {/* ========================================================= */}

    <FormSectionCard
    title="Alternator Details"
    collapsible
    defaultExpanded={false}
    >

    <div style={gridStyle}>

        <Field
        label="Alternator Model"
        value={row.alternator_model}
        />

        <Field
        label="Alternator Number"
        value={row.alternator_number}
        />

    </div>

    </FormSectionCard>


    {/* ========================================================= */}
    {/* PANEL DETAILS */}
    {/* ========================================================= */}

    <FormSectionCard
    title="Panel Details"
    collapsible
    defaultExpanded={false}
    >

    <div style={gridStyle}>

        <Field
        label="Panel Type"
        value={row.panel_type}
        />

        <Field
        label="Panel Serial No"
        value={row.panel_serial_no}
        />

        <Field
        label="Panel Make"
        value={row.panel_make}
        />

        <Field
        label="Phase"
        value={row.phase}
        />

    </div>

    </FormSectionCard>


    {/* ========================================================= */}
    {/* TECHNICAL DETAILS */}
    {/* ========================================================= */}

    <FormSectionCard
    title="Technical Details"
    collapsible
    defaultExpanded={false}
    >

    <div style={gridStyle}>

        <Field
            label="Cooling Type"
            value={row.cooling_type}
        />

        <Field
            label="Running Hours"
            value={row.running_hours}
        />

        <Field
            label="Battery Serial No"
            value={row.battery_serial_no}
        />

        <Field
            label="Tested By"
            value={row.tested_by}
        />

    </div>

    </FormSectionCard>


    {/* ========================================================= */}
    {/* INTERNAL DETAILS */}
    {/* ========================================================= */}

    <FormSectionCard
    title="Internal Details"
    collapsible
    defaultExpanded={false}
    >

    <div style={gridStyle}>

        

        <Field
        label="KGD / Jakson Executive"
        value={row.kgd_jakson_executive}
        />

        <Field
        label="Executive Name"
        value={row.executive_name}
        />

        

        <Field
        label="Plant Location"
        value={row.plant_location}
        />

    </div>

    </FormSectionCard>


    {/* ========================================================= */}
    {/* COMMISSIONING */}
    {/* ========================================================= */}

    <FormSectionCard
    title="Commissioning"
    collapsible
    defaultExpanded={false}
    >

    <div style={gridStyle}>

        <Field
            label="Commissioning Status"
            value={row.commissioning_status}
        />

        <Field
            label="Date of Installation"
            value={row.date_of_installation}
        />

        <Field
            label="Commissioning Date"
            value={row.commissioning_date}
        />

        <Field
            label="Service Dealer"
            value={row.service_dealer}
        />

    </div>

    </FormSectionCard>


    {/* ========================================================= */}
    {/* WARRANTY & AMC */}
    {/* ========================================================= */}

    <FormSectionCard
    title="Warranty & AMC"
    collapsible
    defaultExpanded={false}
    >

    <div style={gridStyle}>

        <Field
        label="Warranty Start Date"
        value={row.warranty_start_date}
        />

        <Field
        label="Warranty End Date"
        value={row.warranty_end_date}
        />

        <Field
        label="AMC Status"
        value={row.amc_status}
        />

    </div>

    </FormSectionCard>

    </div>
  );
}